import script from "./userInfoProfile.vue?vue&type=script&lang=ts&setup=true"
export * from "./userInfoProfile.vue?vue&type=script&lang=ts&setup=true"

import "./userInfoProfile.vue?vue&type=style&index=0&id=40eea1f2&scoped=true&lang=scss"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40eea1f2"]])

export default __exports__